import { connect } from 'react-redux';
import StoreSelectorModal from '../../../components/store/StoreSelectorModal';
import {
  chainsList,
  storeNames,
  categoriesList,
  loadingStores,
  loadingCategories,
  currentChain,
  currentStoreName,
  currentStoreIndex,
  currentCategory,
  currentCategoryKey,
} from 'core/selectors';
import { setChain, getStoreNames, setStoreName, setStore } from 'core/slices/stores';
import { setCategory, resetCategory } from 'core/slices/categories';
import { getTasksProgress } from 'core/slices/tasks';

export default connect(
  state => ({
    chains: chainsList(state),
    storeNames: storeNames(state),
    categories: categoriesList(state),
    loading: loadingStores(state),
    categoryProgressLoading: loadingCategories(state),
    currentChain: currentChain(state),
    currentStoreName: currentStoreName(state),
    currentStoreIndex: currentStoreIndex(state),
    currentCategory: currentCategory(state),
    currentKey: currentCategoryKey(state),
  }),
  {
    setChain,
    getStoreNames,
    setStoreName,
    setStore,
    setCategory,
    resetCategory,
    getTasksProgress,
  },
)(StoreSelectorModal);
